import {
  Autoformat,
  BlockQuote,
  Bold,
  ClassicEditor,
  Essentials,
  GeneralHtmlSupport,
  Heading,
  Image,
  ImageCaption,
  ImageResize,
  ImageStyle,
  ImageTextAlternative,
  ImageToolbar,
  ImageUpload,
  Italic,
  Link,
  List,
  Paragraph,
  PasteFromOffice,
  Table,
  TableCellProperties,
  TableProperties,
  TableToolbar,
} from 'ckeditor5'
import 'ckeditor5/ckeditor5.css'

export const customEditorPlugins = [
  Essentials,
  Autoformat,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Link,
  List,
  BlockQuote,
  PasteFromOffice,
  GeneralHtmlSupport,
  Table,
  TableToolbar,
  TableProperties,
  TableCellProperties,
  Image,
  ImageCaption,
  ImageStyle,
  ImageResize,
  ImageTextAlternative,
  ImageToolbar,
  ImageUpload,
]

export default ClassicEditor
